import { code } from "@spscommerce/utils";

export const SpsTextInputExamples = {
    standard: {
        label: "Standard",
        description: "info about standard text inputs",
        examples: {
            standard: {
                template: code`
                    <form [formGroup]="form" id="standardTextInput">
                        <sps-label for="companyName">
                            Company Name
                            <sps-label-help>This is help text!</sps-label-help>
                        </sps-label>
                        <sps-text-input formControlName="companyName"></sps-text-input>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                companyName: ["", Validators.required]
                            });
                        }
                    }
                `
            }
        }
    },
    placeholder: {
        label: "Placeholder",
        description: "info about text input placeholders",
        examples: {
            placeholder: {
                template: code`
                    <form [formGroup]="form">
                        <sps-label for="companyNameWithPlaceholder">Company Name</sps-label>
                        <sps-text-input formControlName="companyNameWithPlaceholder" placeholder="Enter a company name"></sps-text-input>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                companyNameWithPlaceholder: []
                            });
                        }
                    }
                `
            }
        }
    },
    description: {
        label: "Description",
        description: "info about text inputs with descriptions",
        examples: {
            description: {
                template: code`
                    <form [formGroup]="form">
                        <sps-label for="textInputWithDescription"
                            description="This is a brief description of the field to provide additional context."
                        >
                            Label
                        </sps-label>
                        <sps-text-input formControlName="textInputWithDescription">
                        </sps-text-input>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                textInputWithDescription: []
                            });
                        }
                    }
                `
            }
        }
    },
    disabled: {
        label: "Disabled",
        description: "info about disabled text inputs",
        examples: {
            disabled: {
                template: code`
                    <form [formGroup]="form">
                        <sps-label for="email">Email Address</sps-label>
                        <sps-text-input formControlName="email" id="disabledTextInput"></sps-text-input>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                email: [{ value: "foo@bar.com", disabled: true }]
                            });
                        }
                    }
                `
            }
        }
    }
};
